import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import SectorsIndex from "@/pages/SectorsIndex";
import SectorPage from "@/pages/SectorPage";
import Portfolio from "@/pages/Portfolio";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import GuidesIndex from "@/pages/GuidesIndex";
import GuidePage from "@/pages/GuidePage";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import LocalPage from "@/pages/LocalPage";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import { LOCATIONS } from "@/data/locations";
import { LEGAL } from "@/data/legal";

const AdminApp = lazy(() => import("@/admin/AdminApp"));
const PublicDemo = lazy(() => import("@/demos/PublicDemo"));
const PreviewPage = lazy(() => import("@/pages/PreviewPage"));

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/servizi" element={<ServicesIndex />} />
        <Route path="/servizi/:slug" element={<ServicePage />} />
        <Route path="/soluzioni" element={<SectorsIndex />} />
        <Route path="/soluzioni/:slug" element={<SectorPage />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/prezzi" element={<Pricing />} />
        <Route path="/chi-siamo" element={<About />} />
        <Route path="/guide" element={<GuidesIndex />} />
        <Route path="/guide/:slug" element={<GuidePage />} />
        <Route path="/contatti" element={<Contact />} />
        <Route path="/consulenza-online" element={<Consultation kind="consulenza" />} />
        <Route path="/preventivo-gratuito" element={<Consultation kind="preventivo" />} />
        <Route path="/richiedi-anteprima" element={<Consultation kind="anteprima" />} />
        {LOCATIONS.map((l) => <Route key={l.slug} path={`/${l.slug}`} element={<LocalPage slug={l.slug} />} />)}
        {LEGAL.map((l) => <Route key={l.slug} path={`/${l.slug}`} element={<LegalPage slug={l.slug} />} />)}
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/demo/abbigliamento/*" element={<Suspense fallback={<div className="min-h-screen" />}><PublicDemo /></Suspense>} />
      <Route path="/anteprima/:token/*" element={<Suspense fallback={<div className="min-h-screen bg-[#EAF4FF]" />}><PreviewPage /></Suspense>} />
      <Route path="/admin/*" element={<Suspense fallback={<div className="min-h-screen" />}><AdminApp /></Suspense>} />
    </Routes>
  );
}
